<template>
  <div>
    <v-dialog
      v-model="decisionMakerDialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11" class="text-left">
              <h2 class="text-h5">Update Living Will</h2>
            </v-col>
            <v-col cols="1">
              <v-icon class="close" color="black" @click.stop="closeDialog">{{
                icons.mdiClose
              }}</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text class="crud-card-text">
          <p>
            <strong>{{ decisionMakerObject?.displayName }}</strong> is linked as
            the decision maker in your <strong>living will</strong> and cannot
            be removed without nullifying it.
          </p>
          <p>
            Please visit your living will if you wish to update your decision
            maker
          </p>

          <div class="mt-10 mb-5">
            <GradientButton
              @gradientButtonClicked="navigateLivingWill"
              :title="'UPDATE LIVING WILL'"
              :small="true"
              :callout="'right'"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mdiClose } from '@mdi/js';
  export default {
    name: 'DecisionMakerDialog',
    components: {},
    props: {
      decisionMakerDialog: {
        required: true,
        default: false,
        type: Boolean,
      },
      decisionMakerObject: {
        required: false,
        default: () => {
          return {};
        },
        type: Object,
      },
    },
    data() {
      return {
        icons: {
          mdiClose: mdiClose,
        },
        decisionMakerEmailInput: null,
      };
    },
    methods: {
      closeDialog() {
        this.$emit('decisionMakerDialogHide');
      },
      async saveAndContinue() {
        const isValid = await this.$refs.decisionMakerInput.validate();
        if (isValid.valid) {
          this.closeDialog(this.decisionMakerEmailInput);
        }
      },
      navigateLivingWill() {
        this.$router.push({ name: 'LivingWill' });
      },
    },
    created() {
      this.decisionMakerEmailInput = this.decisionMakerEmail;
    },
  };
</script>
